import { createModel } from '@/store/tools';

const model = {
    namespace: 'sensitiveword',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getSensitiveWordList': T('getSensitiveWordList'),
        },
        actions: {
            'getSensitiveWordList': A('getSensitiveWordList'),
        },
        sagas: {
            'getSensitiveWordList': S('getSensitiveWordList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.SensitiveWordCheckMisService.getSensitiveWordList'),
        },
        reducers: {
            'sensitiveWordList': R('getSensitiveWordList', []),
        }
    })
};
export default createModel(model);